import { render, staticRenderFns } from "./adSite.vue?vue&type=template&id=10fb163e"
import script from "./adSite.vue?vue&type=script&lang=js"
export * from "./adSite.vue?vue&type=script&lang=js"
import style0 from "./adSite.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports